module.exports = __webpack_public_path__ + "static/img/banner08.1c956d1f.png";